import IMG3 from './assets/gallery/caeser-resort.png'
import IMG2 from './assets/gallery/london-home-finder.jpg'
import IMG1 from './assets/gallery/store-screen.png'

import IMG6 from './assets/gallery/dubai-homes.png'
import IMG5 from './assets/gallery/vet-clinic.jpg'
import IMG4 from './assets/gallery/yum-yum.jpg'

import IMG8 from './assets/gallery/car-dealership.jpg'
import IMG9 from './assets/gallery/color-picker.jpg'
import IMG7 from './assets/gallery/github-finder.jpg'

// --- 9 projects
const Data = [
  {
    id: 1,
    image: IMG1,
    title: 'Caeser Store: ',
    description:
      'E-commerce platform built with Next.js and MongoDB, inspired by Amazon shopping experience. Browse products, manage inventory, process payments',
    github: 'https://github.com/caeserlondon/caeser-clothing-store',
    demo: 'https://caeser-store.vercel.app',
  },
  {
    id: 2,
    image: IMG2,
    title: 'London Home Finder: ',
    description:
      'For listings properties for rent and sale. using React, firebase, google Auth, and leaflet-maps.',
    github: 'https://github.com/caeserlondon/london-home-finder',
    demo: 'https://london-home-finder.web.app',
  },
  {
    id: 3,
    image: IMG3,
    title: 'Caeser resort: ',
    description:
      'A modern, responsive hotel management application built with React, TanStack Query, PostgreSQL, Supabase, and Recharts.',
    github: 'https://github.com/caeserlondon/caeser-resort',
    demo: 'https://caeser-resort.vercel.app/',
  },
  {
    id: 4,
    image: IMG4,
    title: 'Yum Yum: ',
    description:
      'Recipe Website using Spoonacular API, Multiple Themes, Made using React 18, React Icons and SASS.',
    github: 'https://github.com/caeserlondon/Yum-Yum',
    demo: 'https://yum-yum-caeserlondon.vercel.app',
  },
  {
    id: 5,
    image: IMG5,
    title: 'Vet Clinic: ',
    description:
      'Building a Veterinary clinic web site with Next V12.2, React V18.2, photos and videos from pexels.com',
    github: 'https://github.com/caeserlondon/vet-clinic',
    demo: 'https://caeser-vet-clinic.vercel.app',
  },

  {
    id: 6,
    image: IMG6,
    title: 'Dubai Homes: ',
    description:
      'Dubai Homes fetches real-time data from RapidAPI to display properties available for sale and for rent using Next.js, React 18, Chakra UI and Emotion.',
    github: 'https://github.com/caeserlondon/dubai-homes',
    demo: 'https://dubai-homes.vercel.app/',
  },

  {
    id: 7,
    image: IMG7,
    title: 'Github Finder: ',
    description:
      'Search for Github users and view their profile, using React, react-router, TailWind and DaisyUI.',
    github: 'https://github.com/caeserlondon/github-user-finder',
    demo: 'https://github-user-finder-caeser.vercel.app',
  },
  {
    id: 8,
    image: IMG8,
    title: 'Car Dealership: ',
    description:
      'Building a fully responsive Classic Car Dealer website, using HTML, CSS, jQuery and font awesome.',
    github: 'https://github.com/caeserlondon/car-dealership',
    demo: 'https://caesers-classic-cars.netlify.app',
  },
  {
    id: 9,
    image: IMG9,
    title: 'Color Picker: ',
    description:
      'Create a random color palette.Created using JavaScript, Chroma.js, HTML5, CSS3 and font awesome.',
    github: 'https://github.com/caeserlondon/Color-Picker',
    demo: 'https://caeser-color-picker.netlify.app',
  },

  // {
  //   id: 6,
  //   image: IMG1,
  //   title: 'Project title: ',
  //   description: 'project description and the technologies used',
  //   github: 'https://github.com',
  //   demo: 'https://netlify.com',
  // },
]
///   9 projects ---
// const Data = [
//   {
//     id: 1,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 2,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 3,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 4,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 5,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 6,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 7,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 8,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
//   {
//     id: 9,
//     image: IMG1,
//     title: 'Project title: ',
//     description: 'project description and the technologies used',
//     github: 'https://github.com',
//     demo: 'https://netlify.com',
//   },
// ]

export default Data
